import { identityApi, unwrapAndParse } from './client';
import { getErrorMessage } from '../get-error-message';
import {
  LoginRequestSchema,
  LoginResultSchema,
  RefreshTokenResponseSchema,
  type LoginResponse,
} from '@autopia/api-contracts';

export async function refreshKioskToken(currentToken: string): Promise<string> {
  const { data } = await identityApi.post(
    '/auth/kiosk/refresh',
    {},
    { headers: { Authorization: `Bearer ${currentToken}` } },
  );
  const parsed = unwrapAndParse(data, RefreshTokenResponseSchema);
  return parsed.accessToken;
}

export async function staffLogin(
  email: string,
  password: string,
): Promise<{ accessToken: string; user: LoginResponse['user'] }> {
  try {
    const payload = LoginRequestSchema.parse({ email, password });
    const { data } = await identityApi.post('/auth/login', payload);
    const parsed = unwrapAndParse(data, LoginResultSchema);
    if ('requires2FA' in parsed) {
      throw new Error(
        'Akun ini memerlukan verifikasi 2FA. Gunakan akun kiosk tanpa 2FA untuk login di perangkat ini.',
      );
    }
    return { accessToken: parsed.accessToken, user: parsed.user };
  } catch (err) {
    throw new Error(getErrorMessage(err));
  }
}
